const supportedLanguages = () => {
  return ["de", "en"];
};

const getLanguageOfUserFromPath = params => {
  return params?.lang ? params.lang : getLanguageOfUser();
};

const getLanguageOfUser = () => {
  const languageFromNavigator =
    self.navigator.browserLanguage || self.navigator.language;
  const languageCode = languageFromNavigator.toString().slice(0, 2);
  if (supportedLanguages().includes(languageCode)) {
    return languageCode;
  }
  return "en";
};

export const languageAdapter = {
  getLanguageOfUserFromPath,
  getLanguageOfUser,
  supportedLanguages
};
